import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToArray',
})
export class EnumToArrayPipe implements PipeTransform {
  transform<
    Type extends Record<string | number, string | number>,
    Key extends keyof Type,
  >(data: Type) {
    const keys = Object.keys(data) as Key[];
    return keys.slice(keys.length / 2);
  }
}

export function enumToArray<
  Type extends Record<string | number, string | number>,
  Key extends keyof Type,
>(data: Type): Key[] {
  const keys = Object.keys(data) as Key[];

  return Array.from(new Set(keys)) as Key[];
}

export function checkIsEnum<
  Type extends Record<string | number, string | number>,
  Key extends keyof Type,
>(value: any, enumData: Type): value is Key {
  return enumToArray(enumData).includes(value.toString() as Key);
}
